<template>
  <div class="page-container">
	<v-toolbar color="secondary" dark class="headline">
    	<v-toolbar-title>Mascotas</v-toolbar-title>
	</v-toolbar>
	<v-container fluid>
        <v-layout row wrap>
			<v-flex xs12 sm4 lg2>
				<v-select class="busqueda-combo" :items="tiposBusqueda" item-text="texto" v-model="busquedaTipo" label="Buscar por" return-object></v-select>
			</v-flex>
			<v-flex xs9 sm7 lg9>
				<v-text-field class="busqueda-textbox" v-model="busquedaTexto" v-on:keyup.enter="buscar()"></v-text-field>
			</v-flex>
			<v-flex xs3 sm1 style="text-align:center">
				<v-btn color="blue" dark @click="buscar()" style="width:90%" >
					<v-icon>search</v-icon>
				</v-btn>
			</v-flex>
        </v-layout>
	</v-container>
	<v-container fluid>
        <v-layout row wrap v-if="buscando==false">
			<v-flex xs12 sm6 md6 pa-1 v-for="mascota in mascotas" :key="mascota.id">
				<v-card>
				<v-container fluid grid-list-lg>
					<v-layout row wrap>
					<v-flex xs12 sm5 style="position:relative">
						<v-img :src="getImageUrl(mascota)" height="300px" style="border-radius:10px" @click="hacerZoom(mascota)" class="grey lighten-2">
							<v-layout slot="placeholder" fill-height align-center justify-center ma-0>
								<v-progress-circular indeterminate color="primary"></v-progress-circular>
							</v-layout>
						</v-img>
						<label v-show="subiendo<=0" style="right:15px!important;bottom:25px!important;position:absolute" :for="'file-input_' + mascota.id" class="input-label">
							<v-btn fab color="blue" dark><v-icon class="fa-fab-icon">fa-camera</v-icon></v-btn>
							<input type="file" class="file-input" :id="'file-input_' + mascota.id" v-on:change="subirFoto(mascota)" />
						</label>
						<v-progress-linear dark style="width:95%!important;bottom:50%;top:50%!important;position:absolute;" 
							v-if="subiendo==mascota.id" height="40" color="blue" :value="progresoSubida">{{ redondearNumero(progresoSubida) }}%</v-progress-linear>
					</v-flex>
					<v-flex xs12 sm7>
						<div class="headline mascotas-titulo" >{{mascota.nombre}}</div>
						<div class="subtitle-1 mascotas-titulo" ><b>Dueño:</b> {{mascota.duenio}}</div>
						<div class="subtitle-1 mascotas-titulo" ><b>Última visita:</b> {{(mascota.ultimaVisita==null)?'-':mascota.ultimaVisita.format()}}</div>
						<div class="subtitle-1 mascotas-titulo" ><b>Raza:</b> {{getRazaYColor(mascota)}}</div>
						<div class="subtitle-1 mascotas-titulo" ><b>Tamaño:</b> {{getTamanioYPeso(mascota)}}</div>
						<v-expansion-panels>
							<v-expansion-panel>
								<v-expansion-panel-header>Mas Info</v-expansion-panel-header>
								<v-expansion-panel-content>
									<div class="subtitle-1 mascotas-titulo" v-if="mascota.descripcion!=null"><b>Carácter:</b> {{mascota.caracter.descripcion}}</div>
									<div class="subtitle-1 mascotas-titulo" v-if="mascota.telefono!=null"><b>Teléfono:</b> {{mascota.telefono}}</div>
									<div class="subtitle-1 mascotas-titulo" v-if="mascota.direccion!=null"><b>Dirección:</b> {{mascota.direccion}}</div>
									<div class="subtitle-1 mascotas-titulo" v-if="mascota.email!=null"><b>E-mail:</b> {{mascota.email}}</div>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
						<v-card-actions style="padding:0px;margin-top: 10px;justify-content:flex-end">
							<v-btn fab style="margin-right:10px!important" color="red" dark @click="confirmarEliminar(mascota)"><v-icon class="fa-fab-icon">fa-trash</v-icon></v-btn>
							<v-btn fab style="margin-right:10px!important" color="blue" dark @click="setEditando(mascota)"><v-icon class="fa-fab-icon">fa-pen</v-icon></v-btn>
							<v-btn fab color="blue" dark @click="irAVisitas(mascota)"><v-icon class="fa-fab-icon">fa-eye</v-icon></v-btn>
						</v-card-actions>
					</v-flex>
					</v-layout>
				</v-container>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap v-if="buscando==true">
			<v-flex xs12 style="text-align: center;">
				<v-progress-circular indeterminate color="primary" size="75" width="10"></v-progress-circular>
			</v-flex>
		</v-layout>
		<div v-if="totalPaginas>1">
			<v-pagination v-model="pagina" :length="totalPaginas"></v-pagination>
		</div>
		<div class="busqueda-sin-resultados" v-if="totalPaginas==-1">
			No se encontraron resultados
		</div>
	</v-container>
	<v-btn color="green" dark fixed bottom right class="btn-very-large" @click="agregarNuevo()" fab>
		<v-icon>add</v-icon>
    </v-btn>
	<v-snackbar top :color="snackMascota" v-model="snackbar">{{ mensaje }}<v-btn color="black" small fab dark @click="snackbar = false"><v-icon class="fa-fab-icon">fa-times</v-icon></v-btn>
    </v-snackbar>
	<v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Eliminar Mascota</span>
        </v-card-title>
        <v-card-text v-if="aEliminar!=null">
			¿Estás seguro que querés eliminar a {{aEliminar.nombre}}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="onCancelarEliminar()">No</v-btn>
          <v-btn color="blue darken-1" dark @click="onConfirmarEliminar()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
	<v-dialog v-model="dialogEditar" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Editar Mascota</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md v-if="mEdit!=null">
			<v-form ref="form">
            	<v-layout wrap>
					<v-flex xs12 sm6>
						<v-text-field label="Nombre" v-model="mEdit.nombre" :rules="[required]"></v-text-field>
					</v-flex>
					<v-flex xs12 sm6>
						<v-text-field label="Dueño" v-model="mEdit.duenio" :rules="[required]"></v-text-field>
					</v-flex>
					<v-flex xs12 sm6>
						<v-select :items="tamanios" label="Tamaño" item-disabled="inactivo" item-text="descripcion" return-object v-model="mEdit.tamanio" :rules="[requiredActivo]"></v-select>
					</v-flex>
					<v-flex xs12 sm6>
						<v-select :items="razas" label="Raza" item-disabled="inactivo" item-text="descripcion" return-object v-model="mEdit.raza" :rules="[requiredActivo]"></v-select>
					</v-flex>
					<v-flex xs12 sm6>
						<v-select :items="caracteres" label="Caracter" item-disabled="inactivo" item-text="descripcion" return-object v-model="mEdit.caracter" :rules="[requiredActivo]"></v-select>
					</v-flex>
					<v-flex xs12 sm6>
						<v-select :items="colores" label="Color" item-disabled="inactivo" item-text="descripcion" return-object v-model="mEdit.color" :rules="[requiredActivo]"></v-select>
					</v-flex>
					<v-flex xs12 sm6>
						<v-text-field label="Peso" v-model="mEdit.peso" number></v-text-field>
					</v-flex>
					<v-flex xs12 sm6>
						<v-text-field label="Teléfono" v-model="mEdit.telefono"></v-text-field>
					</v-flex>
					<v-flex xs12 sm6>
						<v-text-field label="Dirección" v-model="mEdit.direccion"></v-text-field>
					</v-flex>
					<v-flex xs12 sm6>
						<v-text-field label="E-mail" v-model="mEdit.email"></v-text-field>
					</v-flex>
            	</v-layout>
			</v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelar()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="aceptar()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  	<div style="height:80px;width:1px;" v-if="$vuetify.breakpoint.smAndDown">&nbsp;</div>
	<imagen-zoom :show="zoom" :img-src="zoomSrc" :main-url="$root.mainUrl"></imagen-zoom>
  </div>
</template>

<script>
export default {
  name: "mascotas",
  components: {},
  data() {
	return { mascotas: [],snackbar:false,mensaje:'',snackMascota:'success',dialog:false,aEliminar:null,busquedaTexto:'',busquedaTipo:null,
		mEdit:null,dialogEditar:false,tamanios:[],caracteres:[],colores:[],razas:[],
		tiposBusqueda:[{texto:'Nombre',id:'NOMBRE'},
						{texto:'Dueño',id:'DUENIO'},
						{texto:'Teléfono',id:'TELEFONO'},
						{texto:'Raza',id:'RAZA'},
						{texto:'Color',id:'COLOR'}],
		pagina:0,
		totalPaginas:0,
		buscando:false,
		subiendo:0,
		subiendoIdx:0,
		progresoSubida:0,
		zoom:false,
		zoomSrc:null
	};
  },
  created() {
	this.busquedaTipo = this.tiposBusqueda[0];
	this.$root.$on('zoom:off',this.cerrarZoom);
    this.$http.get(this.$root.mainUrl + 'api/mascotas.php?i=1').then(result => {
			result.json().then(elem =>{
				this.tamanios = elem.tamanios;
				this.caracteres = elem.caracteres;
				this.colores = elem.colores;
				this.razas = elem.razas;

				let query= this.$route.query;
				let buscar=false;
				if (query.b!=null && query.t!=null){
					this.setTipo(query.t);
					this.busquedaTexto=query.b;
					if (query.p!=null){
						this.pagina=parseInt(query.p);
					}
					else{
						this.pagina=1;
					}
				}
      		});
      	}, error => {
			this.showMessage('Ocurrió un error al obtener los datos iniciales','error');
      	});
  },
  methods: {
	cerrarZoom:function (){
		this.zoomSrc = null;
		this.zoom=false;
	},
	hacerZoom:function (mascota){
		if (mascota.foto>0){
			this.zoomSrc = mascota.foto + ".jpg";
			this.zoom=true;
		}
	},
	redondearNumero:function(numero){
		return Math.round(numero*100)/100;
	},
	getRazaYColor: function(mascota){
		let desc='';
		if (mascota.raza!=null){
			desc+=mascota.raza.descripcion;
		}
		if (desc.length>0 && mascota.color!=null){
			desc+=' - ';
		}
		if (mascota.color!=null){
			desc+=mascota.color.descripcion;
		}
		return desc;
	},
	getTamanioYPeso: function(mascota){
		let desc='';
		if (mascota.tamanio!=null){
			desc+=mascota.tamanio.descripcion;
		}
		if (desc.length>0 && mascota.peso!=null){
			desc+=' - ';
		}
		if (mascota.peso!=null){
			desc+=mascota.peso + "kg.";
		}
		return desc;
	},
	setTipo: function(idTipo){
		for(let i=0;i<this.tiposBusqueda.length;i++){
			if (idTipo==this.tiposBusqueda[i].id){
				this.busquedaTipo = this.tiposBusqueda[i];
				return;
			}
		}
	},
	buscar: function () {
		if (this.busquedaTexto==null || this.busquedaTexto.trim()==''){
			this.showMessage('Tenés que escribir algo para buscar','error');
			return;
		}
		this.totalPaginas=0;
		if (this.pagina==1){
			this.realizarBusqueda();
		}
		else{
			this.pagina=1;
		}
	},
	realizarBusqueda: function(){
		this.buscando=true;
		let params = 't=' + this.busquedaTipo.id + '&b=' + encodeURI(this.busquedaTexto) + '&p=' + this.pagina;
		window.history.pushState(null,'', 'mascotas?' + params);
		if (this.totalPaginas==0){
			params += '&ini=1';
		}
		
		this.$http.get(this.$root.mainUrl + 'api/mascotas.php?' + params).then(result => {
			result.json().then(elem =>{
				if (elem.cantidad!=null){
					if (elem.cantidad==0){
						this.totalPaginas=-1;
					}
					else{
						this.totalPaginas = parseInt(elem.cantidad);
					}
				}
				this.mascotas = elem.mascotas;
				for(let i=0;i<this.mascotas.length;i++){
					this.$set(this.mascotas[i], 'ultimaVisita', new Date(this.mascotas[i].ultimaVisita));
					this.$set(this.mascotas[i], 'editando', false);
				}
				this.buscando=false;
      		});
      	}, error => {
			//   console.error(error);
			this.showMessage('Ocurrió un error al obtener las mascotas','error');
      	});
	},
	getImageUrl: function(mascota){
		if (mascota.foto==0){
			return this.$root.mainUrl + 'imagenes/icono.png';
		}
		else{
			return this.$root.mainUrl + 'api/thumbnail.php?f=' + mascota.foto + (Modernizr.webp==true?'&webp=1':'');
		}
		// return require('../assets/icono.png');
	},
	setEditando: function(mascota){
		this.agregarItemsDesactivados(mascota);
		this.mEdit = mascota;
		this.dialogEditar = true;
	},
	agregarItemsDesactivados : function(mascota){
		this.agregarItemDesactivado(mascota.color,this.colores);
		this.agregarItemDesactivado(mascota.tamanio,this.tamanios);
		this.agregarItemDesactivado(mascota.caracter,this.caracteres);
		this.agregarItemDesactivado(mascota.raza,this.razas);
	},
	agregarItemDesactivado : function(item,lista){
		if (item.id==-1){
			item.inactivo=true;
			lista.push(item);
		}
	},
	quitarItemsDesactivados : function(){
		this.quitarItemDesactivado(this.colores);
		this.quitarItemDesactivado(this.tamanios);
		this.quitarItemDesactivado(this.caracteres);
		this.quitarItemDesactivado(this.razas);
	},
	quitarItemDesactivado : function(lista){
		let idx=-1;
		for(let i=0;i<lista.length;i++){
			if (lista[i].id==-1){
				idx=i;
				break;
			}
		}
		if (idx>=0){
			lista.splice(idx, 1);
		}
	},
	cancelar: function(){
		// mascota.editando = false;
		this.dialogEditar = false;
		if (this.mEdit.id==null){
			this.mascotas.pop();
			this.mEdit = null;
		}
	},
	confirmarEliminar: function(mascota){
		this.aEliminar = mascota;
		this.dialog = true;
	},
	onConfirmarEliminar: function(){
		this.dialog = false;
		this.eliminar(this.aEliminar);
	},
	onCancelarEliminar: function(){
		this.dialog = false;
		this.aEliminar = null;
	},
	eliminar: function(mascota){
		mascota.operacion = "ELIMINAR";
		this.$http.post(this.$root.mainUrl + 'api/mascotas.php',mascota).then(result => {
			result.json().then(elem =>{
				let idx=this.getIndex(mascota);
				this.mascotas.splice(idx, 1);
				this.snackbar = true;
				this.mensaje = "Mascota eliminada correctamente";
				this.aEliminar = null;
			});
		}, error => {
			this.showMessage('Ocurrió un error al eliminar la mascota','error');
			// console.error(error);
		});
	},
	aceptar: function(mascota){
		if (!this.$refs.form.validate()) {return;}
		mascota.operacion = "GUARDAR";
		this.$http.post(this.$root.mainUrl + 'api/mascotas.php',mascota).then(result => {
			result.json().then(elem =>{
				if (elem.id!=null){
					mascota.id=elem.id;
					this.showMessage('Mascota creada correctamente','success');
				}
				else{
					this.showMessage('Mascota actualizada correctamente','success');
				}
				this.dialogEditar = false;
			});
		}, error => {
			this.showMessage('Ocurrió un error al actualizar la mascota','error');
			// console.error(error);
		});
	},
	agregarNuevo: function(){
		let mascota = {editando:true,nombre:null,id:null,tamanio:null,raza:null,caracter:null,duenio:null,color:null};
		this.mEdit = mascota;
		this.dialogEditar = true;
		this.mascotas.push(mascota);
	},
	getIndex: function(mascota){
		for (let i=0;i<this.mascotas.length;i++){
			if (this.mascotas[i].id==mascota.id){
				return i;
			}
		}
		return -1;
	},
	showMessage: function(message,style){
		this.snackMascota = style;
		this.mensaje = message;
		this.snackbar = true;
	},
	required: function(val){
		return val!=null || 'El campo es requerido';
	},
	requiredActivo: function(val){
		return (val!=null && val.id!=-1) || 'El campo es requerido';
	},
	irAVisitas: function(mascota){
		this.$router.push('/visitas/' + mascota.id);
	},
	subirFoto: function(mascota){
		this.snackbar=false;
		//ME FIJO QUE NO HAYA ERRORES EN EL ARCHIVO A SUBIR
		var inputFoto = document.getElementById('file-input_' + mascota.id);
		let archivo = inputFoto.files[0];
		let nomArch = archivo.name.toLowerCase();
		if (nomArch.indexOf('.jpg', nomArch.length - 4) == -1){
			this.showMessage('ERROR DE TIPO DE ARCHIVO','error');
			inputFoto.value = "";
			return;
		}
		if (archivo.type!="" && archivo.type!="image/jpeg"){
			this.showMessage('ERROR DE TIPO DE ARCHIVO','error');
			inputFoto.value = "";
			return;
		}
		if (archivo.size>=(5*1024*1024)){
			this.showMessage('ARCHIVO MUY GRANDE','error');
			inputFoto.value = "";
			return;
		}
		this.progresoSubida=0;
		this.subiendo=mascota.id;
		

		//SI ESTA TODO BIEN, LO SUBO
		// var vFD = new FormData(document.getElementById('upload_form'));
		var vFD = new FormData();
		vFD.append('file',archivo);
		vFD.append('mascotaId',mascota.id);
		var oXHR = new XMLHttpRequest();
		oXHR.upload.addEventListener('progress', this.uploadProgress, false);
		oXHR.addEventListener('load', this.uploadFinish, false);
		oXHR.addEventListener('error', this.uploadError, false);
		oXHR.addEventListener('abort', this.uploadAbort, false);
		oXHR.open('POST', this.$root.mainUrl + 'api/foto-upload.php');
		oXHR.send(vFD);
	},
	uploadProgress:function(e){
		if (e.lengthComputable) {
			//var iPercentComplete = Math.round(e.loaded * 100 / e.total);
			var iPercentComplete = e.loaded * 100 / e.total;
			this.progresoSubida=iPercentComplete;
		} else {
			//document.getElementById('progress').innerHTML = 'unable to compute';
		}
	},
	uploadFinish:function(e) { // upload successfully finished
		this.subiendo=0;
		let response=JSON.parse(e.target.responseText);
		var inputFoto = document.getElementById('file-input_' + response.mascotaId);
		inputFoto.files=null;
		inputFoto.value = "";
		this.refreshImagenByMascotaId(response.mascotaId,response.fotoId);
	},
	uploadError:function (e) { // upload error
		this.subiendo=0;
		this.showMessage("OCURRIO UN ERROR AL SUBIR EL ARCHIVO",'error');
	},
	uploadAbort:function (e) { // upload abort
		this.subiendo=0;
		this.showMessage("SUBIDA ABORTADA",'error');
	},
	refreshImagenByMascotaId: function(idMascota,idFoto){
		let idx=-1;
		for (let i = 0;i<=this.mascotas.length;i++){
			if (this.mascotas[i].id==idMascota){
				this.$set(this.mascotas[i], 'foto', idFoto);
				break;
			}
		}
	}
  },
  watch:{
	pagina: function(val){
		//scrollToTop();
		this.realizarBusqueda();
	}
  }
};
</script>
<style>
.page-container{
	padding-top:60px;
}
.fa-fab-icon{
	font-size: 1.5em!important;
}
.btn-very-large{
	height: 66px!important;
	width: 66px!important;
}
.btn-very-large i{
	font-size: 3.5em!important;
}
.mascotas-titulo{
	min-height:40px;
}
.input-mascotas{
	padding-top: 0px!important;
	padding-bottom: 0px!important;
	margin-top: 0px!important;
	margin-bottom: 0px!important;
}
.input-mascotas .v-text-field__details{
	display: none;
}
.file-input {
	cursor: pointer;
	outline: none;
	position: absolute;
	top: 0;
	left: 0;
	width: 56px;
	height: 56px;
	overflow: hidden;
	filter: alpha(opacity=0);
	/* IE < 9 */
	opacity: 0;
}

.input-label {
	cursor: pointer;
	position: relative;
	display: inline-block;
}
.busqueda-combo{
	margin-left: 5px!important;
    margin-right: 5px!important;
}
.busqueda-textbox{
	margin-left: 5px!important;
}
.busqueda-sin-resultados{
	border: 1px solid #FFFF00;
    background-color: #FFFFCC;
    text-align: center;
	line-height: 50px;
}
</style>
